import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { APP_CONFIG } from '@core/config/app-config.token';
import { injectBrand } from '@core/config/brand';
import { ThemeService } from '@core/services/theme/theme.service';

@Component({
  selector: 'recrewt-powered-by-layout',
  templateUrl: './powered-by-layout.component.html',
  styleUrls: ['./powered-by-layout.component.scss'],
  imports: [RouterOutlet, ExtendedModule, AsyncPipe],
})
export class PoweredByLayoutComponent implements OnInit {
  private appConfig = inject(APP_CONFIG);

  readonly brand = injectBrand();

  readonly isDark$ = inject(ThemeService).isDark$;

  watermarkSrc =
    this.appConfig.modules.home.watermarkSrc ??
    this.appConfig.modules.home.imageSrc ??
    this.appConfig.modules.home.logoSrc;

  /** A watermark made for light backgrounds gets its dark-mode variant, if the fair has one. */
  readonly watermarkDarkSrc = this.appConfig.modules.home.watermarkDarkSrc ?? this.watermarkSrc;

  position = 'bottom-left';

  ngOnInit() {
    //if current page url contains story then position should be set to top-right
    if (window.location.href.includes('story')) {
      // `story.showToolbar`: under the toolbar, which sits on top from tablets up
      this.position = this.appConfig.modules.story.showToolbar
        ? 'top-right below-toolbar'
        : 'top-right';
    }
  }
}
